import type { Attendance } from "../types";
import { useI18n } from "../i18n";

export function effectiveChargeType(chargeType: string, billingIntent?: string | null): string {
  return billingIntent === "pass_pending" ? "pass_pending" : chargeType;
}

export function chargeTypeLabel(chargeType: string): string {
  if (chargeType === "dropin") return "Drop-in";
  if (chargeType === "pass_pending") return "Pass pending";
  if (chargeType === "pass") return "Class pass";
  if (chargeType === "unlimited") return "Unlimited";
  return chargeType.replace(/[_-]+/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function ChargeBadge({ chargeType, billingIntent }: {
  chargeType: Attendance["charge_type"]; billingIntent?: Attendance["billing_intent"];
}) {
  const { t } = useI18n();
  const effective = effectiveChargeType(chargeType, billingIntent);
  const label = effective === "dropin" ? t("dropIn") : effective === "pass_pending" ? t("passPending")
    : effective === "pass" ? t("classPass") : effective === "unlimited" ? t("unlimited") : chargeTypeLabel(effective);
  return <span className={"charge-badge charge-badge-" + effective}>{label}</span>;
}

export function AttendanceChargeBadge({ attendance }: { attendance: Attendance }) {
  const effective = effectiveChargeType(attendance.charge_type, attendance.billing_intent);
  let label = chargeTypeLabel(effective);
  if (effective === "dropin") {
    const amount = attendance.dropin_amount_minor;
    const currency = attendance.dropin_currency || "GBP";
    const money = amount == null ? "" : ` ${currency} ${(amount / 100).toFixed(2)}`;
    label += money + (attendance.dropin_payment_status ? ` ${attendance.dropin_payment_status}` : "");
  }
  return <span className={"charge-badge charge-badge-" + effective}>{label}</span>;
}

export function AttendanceMeta({ dateTime, chargeType, billingIntent }: {
  dateTime: string; chargeType: Attendance["charge_type"]; billingIntent?: Attendance["billing_intent"];
}) {
  return <div className="attendance-meta">
    <time dateTime={dateTime}>{dateTime}</time>
    <ChargeBadge chargeType={chargeType} billingIntent={billingIntent} />
  </div>;
}